'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import StaffHeader from './attdComponents/staffHeader';
import StaffBody from './attdComponents/staffBody';
import attdAction from '../actions/attdAction';
import attdStore from '../stores/attdStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import userStore from '../stores/userStore';
import menuAction from '../actions/menuAction';
import AllBody from './attdComponents/allBody';
import Loading from './loading';

class AttendanceIndividual extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.state = {
            staffAtd: attdStore.getState().staffAtd,
            selectedYear: attdStore.getState().selectedYear,
            selectedMonth: attdStore.getState().selectedMonth,
            processing: attdStore.getState().processing,
            displayMode: 0,
            role: userStore.getState().role,

            filterProcessing: filterStore.getState().processing,
            iniLoadHoliday: filterStore.getState().iniLoadHoliday,
            holiday: filterStore.getState().holiday
        };
    }

    componentDidMount() {
        attdStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        filterStore.listen(this.onFilterChange);
        menuAction.pageNumber.defer(-1);
    

        if (!this.state.processing) {
            attdAction.processing(true);
            attdAction.getStaffAttendance(this.props.match.params.id, this.state.selectedYear, this.state.selectedMonth);
        }
        if(!this.state.filterProcessing  && !this.state.iniLoadHoliday){
            filterAction.processing(true);
            filterAction.getHoliday();
        }

    }
    componentWillUnmount() {
        attdStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
        filterStore.unlisten(this.onFilterChange);
    }
    onUserChange(state) {
        this.setState({
            role: state.role
        });
    }
    onFilterChange(state){
        this.setState({
            filterProcessing: state.processing,
            iniLoadHoliday: state.iniLoadHoliday,
            holiday: state.holiday,
        });
    }
    onChange(state) {
        this.setState({
            staffAtd: state.staffAtd,
            selectedMonth: state.selectedMonth,
            selectedYear: state.selectedYear,
            processing: state.processing,
        });
    }
    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));

        this.setState({ displayMode: index });
    }
    render() {
        let bodyDisplay = '';
        if (this.state.displayMode == 0) {
            bodyDisplay = <AllBody staffsAtd={this.state.staffAtd != "" ? [this.state.staffAtd] : []} useFor={1} role={this.state.role} processing={this.state.processing} />;
        } else {
            bodyDisplay = <StaffBody staffAtd={this.state.staffAtd} selectedYear={this.state.selectedYear} selectedMonth={this.state.selectedMonth} holiday={this.state.holiday}/>;
        }

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 atd">
                        <StaffHeader staffAtd={this.state.staffAtd} staffId={this.props.match.params.id} selectedYear={this.state.selectedYear} selectedMonth={this.state.selectedMonth} />
                        <div className="divider"></div>
                        <div className="atd-i-dp">
                            <div className="atd-dis">Mode: </div>
                            <div className="btn-group" role="group">
                                <button className={"btn btn-default " + (this.state.displayMode == 0 ? "active" : "")} data-index="0" onClick={this.handleClick}>
                                    <span className="glyphicon glyphicon-th-list"></span>
                                </button>
                                <button className={"btn btn-default " + (this.state.displayMode == 1 ? "active" : "")} data-index="1" onClick={this.handleClick}>
                                    <span className="glyphicon glyphicon-th"></span>
                                </button>
                            </div>
                        </div>
                        {bodyDisplay}
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.filterProcessing}/>
            </div>
        );
    }
}
export default AttendanceIndividual;


// WEBPACK FOOTER //
// ./app/components/attendanceIndividual.js